export type LoadingDataReducerStateType = 'ok' | 'loading' | 'error';
export type LoadingDataReducerActionType = 'ok' | 'loading' | 'error' | 'init';

export type LoadingDataReducerState<T> =
    | {
          data: T;
          state: 'ok';
      }
    | {
          data?: T;
          state: 'loading';
      }
    | {
          data?: T;
          state: 'error';
      };

export interface LoadingDataReducerAction<T> {
    type: LoadingDataReducerActionType;
    payload?: T;
}

export function loadingDataReducer<T>(
    prevState: LoadingDataReducerState<T>,
    action: LoadingDataReducerAction<T>,
): LoadingDataReducerState<T> {
    switch (action.type) {
        case 'ok': {
            return {
                data: action.payload!,
                state: 'ok',
            };
        }
        case 'error': {
            return {
                data: prevState.data,
                state: 'error',
            };
        }
        case 'loading': {
            return {
                data: prevState.data,
                state: 'loading',
            };
        }

        case 'init': {
            return {
                data: undefined,
                state: 'loading',
            };
        }
    }
}
